"use client";

import { MessageCircle, Plus } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Card } from "@/components/ui/card";
export default function TechnicalFaq() {
  const faqs = [{
    question: "Wie funktioniert die Installation im Dachboden?",
    answer: "Das Ducted AC System wird diskret im Dachboden oder Spitzboden montiert. Von dort aus verteilen wir die konditionierte Luft über flache, unauffällige Deckenventile in Ihre Wohnräume, wodurch keine störenden Geräte an den Wänden sichtbar sind."
  }, {
    question: "Ist das System auch zum Heizen geeignet?",
    answer: "Ja, absolut. Unsere Anlagen sind als vollwertige Heizsysteme konzipiert. Sie arbeiten hocheffizient und ermöglichen es Ihnen, die gesetzlichen Anforderungen des EWärmeG Baden-Württemberg durch den Einsatz erneuerbarer Energien spielend zu erfüllen."
  }, {
    question: "Wie laut ist der Betrieb im Schlafzimmer?",
    answer: "Durch die zentrale Installation im Dachboden und die schallgedämmte Kanalführung ist das System im Wohnbereich nahezu lautlos. Sie genießen eine zugfreie und flüsterleise Klimatisierung, die für einen erholsamen Schlaf optimiert ist."
  }, {
    question: "Für welche Gebäudetypen ist das System ideal?",
    answer: "Wir empfehlen diese Lösung besonders für Einfamilienhäuser, Reihenhäuser mit ausgebautem Dachgeschoss sowie Wohnungen unter dem Dach. Auch in Räumen mit hohen Decken sorgt die kanalbasierte Verteilung für eine gleichmäßige und angenehme Temperatur."
  }, {
    question: "Wie erfolgt die Wartung der Anlage?",
    answer: "Die Wartung ist unkompliziert und erfolgt über den zentralen Zugang im Dachboden. Wir empfehlen eine jährliche Inspektion, bei der die Filter gereinigt oder gewechselt werden, um eine dauerhaft hohe Luftqualität und Effizienz zu gewährleisten."
  }, {
    question: "Können einzelne Räume separat gesteuert werden?",
    answer: "Ja, durch den Einsatz von Zonenklappen in den Luftkanälen können Sie die Temperatur in verschiedenen Räumen individuell regeln. So heizen oder kühlen Sie nur dort, wo es gerade benötigt wird, was die Energieeffizienz weiter steigert."
  }, {
    question: "Wie lange dauert die Installation?",
    answer: "In der Regel ist die Installation in einem Einfamilienhaus innerhalb weniger Tage abgeschlossen. Da die Hauptkomponenten im Dachboden untergebracht sind, bleibt Ihr Wohnbereich während der Montage weitgehend ungestört."
  }, {
    question: "Was passiert bei einem Defekt?",
    answer: "Als Marktführer für private Klimatisierung bieten wir einen umfassenden Service. Sollte eine Störung auftreten, ist unser technischer Kundendienst schnell vor Ort, um die Anlage zu prüfen und eine zügige Instandsetzung sicherzustellen."
  }];
  return <section data-section-id="618" id="häufige-fragen-zur-technik" className="relative overflow-hidden bg-background py-32 text-foreground">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.04]" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} />

      {}
      <div className="pointer-events-none absolute -bottom-40 -right-40 h-[600px] w-[600px] rounded-lg opacity-30 blur-3xl" style={{
      background: "radial-gradient(circle, hsla(186, 100%, 48%, 0.2) 0%, transparent 70%)"
    }} />

      <div className="relative mx-auto max-w-4xl px-6">
        {}
        <div className="mb-20 text-center">
          <p className="font-mono mb-6 text-xs font-medium uppercase tracking-[0.3em] text-primary">
            Häufige Fragen
          </p>
          <h2 className="font-default text-5xl font-light leading-[1.1] text-foreground md:text-[4rem]">
            Alles zur{" "}
            <em className="font-normal italic text-primary">
              Technik
            </em>
          </h2>
          <p className="mx-auto mt-8 max-w-2xl font-default text-base leading-relaxed text-foreground/70 md:text-lg">
            Hier finden Sie Antworten auf die wichtigsten Fragen zu unserer Ducted AC System Technologie. Für individuelle Anliegen steht Ihnen unser Expertenteam jederzeit zur Verfügung.
          </p>
        </div>

        {}
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} data-index={i} value={`item-${i}`} className="group border-0 border-t border-border last:border-b last:border-b-border">
              <AccordionTrigger className="relative flex items-start gap-4 py-8 pr-2 hover:no-underline md:gap-8 md:py-10 md:pl-16 [&>svg]:hidden">
                {}
                <span className="font-default shrink-0 text-base italic text-primary md:absolute md:left-0 md:top-10 md:text-lg">
                  {String(i + 1).padStart(2, "0")}
                </span>

                {}
                <span className="font-default flex-1 text-left text-xl font-light leading-snug text-foreground md:text-2xl">
                  {faq.question}
                </span>

                {}
                <span className="relative flex h-8 w-8 shrink-0 items-center justify-center text-primary transition-transform duration-300 group-data-[state=open]:rotate-45">
                  <Plus className="h-6 w-6" strokeWidth={1.25} />
                </span>
              </AccordionTrigger>

              <AccordionContent className="pb-10 pl-0 pr-2 md:pl-16 md:pr-12">
                <p className="font-default text-[1.0625rem] leading-[1.8] text-foreground/75">
                  {faq.answer}
                </p>
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>

        {}
        <div className="mt-20 flex justify-center">
          <Card className="flex flex-row items-center gap-5 border border-border bg-card px-8 py-5 shadow-lg">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent">
              <MessageCircle className="h-5 w-5 text-primary" strokeWidth={1.5} />
            </span>
            <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:gap-3">
              <span className="font-default text-base italic text-foreground">
                Noch Fragen offen?
              </span>
              <Link to="/ContactPage" className="font-default text-sm font-medium tracking-wide text-primary underline decoration-primary/40 decoration-1 underline-offset-4 transition-colors hover:text-primary/80 hover:decoration-primary">
                Kontaktieren Sie uns →
              </Link>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}